import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GlobalResetService {
  private resetCallbacks: (() => void)[] = [];

  /**
   * Registers a callback function to be executed when the application state needs to be reset.
   * @param callback The function to execute.
   */
  register(callback: () => void): void {
    this.resetCallbacks.push(callback);
  }

  /**
   * Executes all registered reset callbacks.
   * This should be called when navigating to the Home page or starting a new session.
   */
  resetAll(): void {
    this.resetCallbacks.forEach(callback => {
      try {
        callback();
      } catch (error) {
        console.error('Error during global reset:', error);
      }
    });
  }
}
